import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


import Team from "./components/Team";
import Cause from "./components/Cause";
import TheIndependent from "./components/TheIndependent";
import Worldview from "./components/Worldview";
import { HelmetProvider } from "react-helmet-async";
import Homepage  from "./components/Homepage";


function App() {
  return (
    <HelmetProvider>
      <Router>
      <Routes>
        {/* Homepage route */}
         
        <Route path="/" element={<Homepage />} />
        
      </Routes>
    </Router>
    </HelmetProvider>
  );
}

export default App;